if (!customElements.get('accordion-with-images')) {
class AccordionWithImages extends HTMLElement {
  constructor() {
    super();
    this.faqItems = [];
    this.imageItems = [];
  }

  connectedCallback() {
    this.faqItems = Array.from(this.querySelectorAll('.faq-item'));
    this.imageItems = Array.from(this.querySelectorAll('.image-item'));

    if (!this.faqItems.length || !this.imageItems.length) return;

    this.faqItems.forEach((faqItem) => {
      const heading = faqItem.querySelector('.item-heading');
      const content = faqItem.querySelector('.item-text');
      const itemId = faqItem.getAttribute('data-id');

      if (!heading || !content || !itemId) return;

      heading.addEventListener('click', () => {
        this.toggleAccordion(faqItem, content, itemId);
      });

      heading.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleAccordion(faqItem, content, itemId);
        }
      });
    });
  }

  toggleAccordion(clickedFaqItem, clickedContent, itemId) {
    const activeFaqItem = this.querySelector('.faq-item.active');

    if (activeFaqItem && activeFaqItem !== clickedFaqItem) {
      const activeContent = activeFaqItem.querySelector('.item-text');
      const activeId = activeFaqItem.getAttribute('data-id');
      const activeImageItem = this.imageItems.find(item => item.getAttribute('data-id') === activeId);

      if (activeContent) activeContent.style.maxHeight = null;
      activeFaqItem.classList.remove('active');
      if (activeImageItem) activeImageItem.classList.remove('active');
    }

    if (!clickedFaqItem.classList.contains('active')) {
      clickedContent.style.maxHeight = clickedContent.scrollHeight + 'px';
      clickedFaqItem.classList.add('active');
      const clickedImageItem = this.imageItems.find(item => item.getAttribute('data-id') === itemId);
      if (clickedImageItem) clickedImageItem.classList.add('active');
    }
  }
}

customElements.define('accordion-with-images', AccordionWithImages);
}